const AVALIACAO_RESPOSTA_TIPO = {
  1: { questao_id: 1, avaliacao_questao_tipo_id: 'escala_linear' },
  2: { questao_id: 2, avaliacao_questao_tipo_id: 'multipla_escolha_unica' },
  3: { questao_id: 3, avaliacao_questao_tipo_id: 'likert' },
  4: { questao_id: 4, avaliacao_questao_tipo_id: 'numero' },
  5: { questao_id: 5, avaliacao_questao_tipo_id: 'dicotomica' },
  6: { questao_id: 6, avaliacao_questao_tipo_id: 'multipla_escolha_multipla' },
  7: { questao_id: 7, avaliacao_questao_tipo_id: 'data' },
  8: { questao_id: 8, avaliacao_questao_tipo_id: 'multipla_escolha_unica' },
  9: { questao_id: 9, avaliacao_questao_tipo_id: 'likert' },
  10: { questao_id: 10, avaliacao_questao_tipo_id: 'escala_linear' },
  11: { questao_id: 11, avaliacao_questao_tipo_id: 'numero' },
  12: { questao_id: 12, avaliacao_questao_tipo_id: 'multipla_escolha_multipla' },
  13: { questao_id: 13, avaliacao_questao_tipo_id: 'dicotomica' },
  14: { questao_id: 14, avaliacao_questao_tipo_id: 'multipla_escolha_unica' },
  15: { questao_id: 15, avaliacao_questao_tipo_id: 'likert' },
  16: { questao_id: 16, avaliacao_questao_tipo_id: 'data' },
  17: { questao_id: 17, avaliacao_questao_tipo_id: 'escala_linear' },
  18: { questao_id: 18, avaliacao_questao_tipo_id: 'numero' },
  19: { questao_id: 19, avaliacao_questao_tipo_id: 'multipla_escolha_unica' },
  20: { questao_id: 20, avaliacao_questao_tipo_id: 'dicotomica' },
  21: { questao_id: 21, avaliacao_questao_tipo_id: 'multipla_escolha_multipla' },
  22: { questao_id: 22, avaliacao_questao_tipo_id: 'likert' },
  23: { questao_id: 23, avaliacao_questao_tipo_id: 'escala_linear' },
  24: { questao_id: 24, avaliacao_questao_tipo_id: 'data' },
  25: { questao_id: 25, avaliacao_questao_tipo_id: 'multipla_escolha_unica' },
  26: { questao_id: 26, avaliacao_questao_tipo_id: 'numero' },
  27: { questao_id: 27, avaliacao_questao_tipo_id: 'dicotomica' },
  28: { questao_id: 28, avaliacao_questao_tipo_id: 'likert' },
  29: { questao_id: 29, avaliacao_questao_tipo_id: 'multipla_escolha_multipla' },
  30: { questao_id: 30, avaliacao_questao_tipo_id: 'escala_linear' },
  31: { questao_id: 31, avaliacao_questao_tipo_id: 'multipla_escolha_unica' },
  32: { questao_id: 32, avaliacao_questao_tipo_id: 'numero' },
  33: { questao_id: 33, avaliacao_questao_tipo_id: 'dicotomica' },
  34: { questao_id: 34, avaliacao_questao_tipo_id: 'data' },
  35: { questao_id: 35, avaliacao_questao_tipo_id: 'likert' },
  36: { questao_id: 36, avaliacao_questao_tipo_id: 'multipla_escolha_unica' }
};

export default AVALIACAO_RESPOSTA_TIPO;
